import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _assetsAnimationLoading_gray_slowGif from "../../../../assets/animation/loading_gray_slow.gif";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useState, useRef, useMemo, useEffect } from 'react';
import { View, Text, Image, TouchableOpacity, Pressable, DeviceEventEmitter } from 'react-native';
import UploadImage from '../../../Image/rn/UploadImage';
import UploadVideo from '../../../Image/rn/UploadVideo';
import MediaDelete from '../../../Image/rn/MediaDelete';
import UploadFailed from '../../../Image/rn/UploadFailed';
import MediaSelect, { MediaType } from './MediaSelect';
import { filterNullObj, formatMediaTokens } from '../config';
import { MediaConstants, MediaSourceType, UPLOAD_VIDEO_ERROR_STATUS, UploadMediaResStatus, UploadMediaStatus } from '../common';
import { MIX_MEDIA_IN_ROW_COUNT, MIX_MEDIA_MARGIN_RIGHT, styles } from './FileUpload';
/* eslint-disable @typescript-eslint/no-var-requires */

var module = {
  exports: {}
};
var exports = module.exports;
var Loading = _assetsAnimationLoading_gray_slowGif;
var UploadStatus;
(function (UploadStatus) {
  UploadStatus[UploadStatus["Loading"] = 0] = "Loading";
  UploadStatus[UploadStatus["Fail"] = 1] = "Fail";
  UploadStatus[UploadStatus["Success"] = 2] = "Success";
  UploadStatus[UploadStatus["Checked"] = 3] = "Checked";
})(UploadStatus || (UploadStatus = {}));
export var EVIDENCE_QUALITIES = {
  EVIDENCE_QUALITY_UNKNOWN: 0,
  EVIDENCE_QUALITY_EXTREMELY_HIGH_BBD: 1,
  EVIDENCE_QUALITY_HIGH_BBD: 2,
  EVIDENCE_QUALITY_NORMAL: 3
};
export var MixedFileUpload = function MixedFileUpload(props) {
  var imageProps = props.imageProps,
    videoProps = props.videoProps,
    onChange = props.onChange,
    _props$value = props.value,
    value = _props$value === void 0 ? {
      imagesList: [],
      videosList: []
    } : _props$value,
    getCurRootTag = props.getCurRootTag,
    sessionId = props.sessionId,
    postVideoPreUpload = props.postVideoPreUpload,
    checkQuantity = props.checkQuantity,
    warningText = props.warningText;
  var rootTag = Number(getCurRootTag === null || getCurRootTag === void 0 ? void 0 : getCurRootTag());
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showWarning = _useState2[0],
    setShowWarning = _useState2[1];
  var _useState3 = useState({
      imagesList: [],
      videosList: []
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    originFileMap = _useState4[0],
    setOriginFileMap = _useState4[1];
  var originFileMapRef = useRef({
    imagesList: [],
    videosList: []
  }); // 所有被移除的图片

  var removeImageIdsList = useRef([]);
  var valueMap = useRef(value);
  useEffect(function () {
    valueMap.current = value;
  }, [value]);
  var restImageNum = useMemo(function () {
    return imageProps.maxFileNum - originFileMapRef.current.imagesList.length;
  }, [imageProps, originFileMap]);
  var showImageUploadIcon = useMemo(function () {
    if (imageProps.hidden || imageProps.maxFileNum && originFileMap.imagesList.length >= imageProps.maxFileNum) {
      return false;
    }
    return true;
  }, [imageProps, originFileMap]);
  var showVideoUploadIcon = useMemo(function () {
    if (videoProps.hidden || videoProps.maxFileNum && originFileMap.videosList.length >= videoProps.maxFileNum) {
      return false;
    }
    return true;
  }, [videoProps, originFileMap]); // 是否存在质量为bad的照片或视频

  var hasBadQuality = function hasBadQuality(fileList) {
    return fileList.findIndex(function (item) {
      return item.evidenceQuality === EVIDENCE_QUALITIES.EVIDENCE_QUALITY_HIGH_BBD;
    }) !== -1;
  };
  var handleRemove = function handleRemove(index, file, isImage) {
    var newFileList = isImage ? _toConsumableArray(originFileMap.imagesList) : _toConsumableArray(originFileMap.videosList);
    removeImageIdsList.current = [].concat(_toConsumableArray(removeImageIdsList.current), [file.id]);
    newFileList.splice(index, 1);
    var newOriginFileMap = isImage ? {
      imagesList: newFileList,
      videosList: originFileMap.videosList
    } : {
      imagesList: originFileMap.imagesList,
      videosList: newFileList
    };
    setOriginFileMap(newOriginFileMap);
    originFileMapRef.current = newOriginFileMap; // 如果还没有 url, 说明还没有上传成功, 不存在于 value中

    if (!(file !== null && file !== void 0 && file.url)) {
      return;
    } // 去掉 value 中的所选项

    var newValueList = isImage ? _toConsumableArray(valueMap.current.imagesList) : _toConsumableArray(valueMap.current.videosList); // 查找 value 中对应的 index

    var valueIndex = newValueList.findIndex(function (item) {
      return item.id === file.id;
    });
    newValueList.splice(valueIndex, 1);
    var newValue = {
      imagesList: isImage ? newValueList : valueMap.current.imagesList,
      videosList: isImage ? valueMap.current.videosList : newValueList
    };
    var hasBadImage = hasBadQuality(newValue === null || newValue === void 0 ? void 0 : newValue.imagesList);
    setShowWarning(hasBadImage);
    onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
  };
  var handleRetry = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(index, fileInfo, isImage) {
      var newFileList, newOriginFileList;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!(fileInfo.uploadStatus === UploadStatus.Loading)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              newFileList = isImage ? _toConsumableArray(originFileMap.imagesList) : _toConsumableArray(originFileMap.videosList);
              newFileList[index] = _objectSpread(_objectSpread({}, fileInfo), {}, {
                uploadStatus: UploadStatus.Loading
              });
              newOriginFileList = isImage ? {
                imagesList: newFileList,
                videosList: originFileMap.videosList
              } : {
                imagesList: originFileMap.imagesList,
                videosList: newFileList
              };
              setOriginFileMap(newOriginFileList);
              originFileMapRef.current = newOriginFileList;
              if (!isImage) {
                _context.next = 13;
                break;
              }
              _context.next = 11;
              return handleImageUpload([{
                id: fileInfo.id,
                imageFilePath: fileInfo.imageFilePath
              }]).catch(function (error) {
                console.error('[MixedFileUpload] Image Upload Failed', error);
              });
            case 11:
              _context.next = 15;
              break;
            case 13:
              _context.next = 15;
              return handleVideosUpload([fileInfo.id]).catch(function (error) {
                console.error('[MixedFileUpload] Video Upload Failed', error);
              });
            case 15:
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](0);
              console.error('[MixedFileUpload] retry Upload Failed', _context.t0);
            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 17]]);
    }));
    return function handleRetry(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(); // 添加视频上传的监听

  var addVideosListener = function addVideosListener(videoUploadIdsMap, callback) {
    var _MediaSelect$mediaSta;
    MediaSelect === null || MediaSelect === void 0 ? void 0 : (_MediaSelect$mediaSta = MediaSelect.mediaStartListeningForUploadProgress) === null || _MediaSelect$mediaSta === void 0 ? void 0 : _MediaSelect$mediaSta.call(MediaSelect, rootTag);
    DeviceEventEmitter.addListener('MEDIA_SELECT_UPLOAD_PROGRESS_EVENT', function (res) {
      var _originFileMapRef$cur, _originFileMapRef$cur2;
      var result = {};
      try {
        result = JSON.parse(res);
      } catch (error) {
        console.error('[MixedFileUpload] add Video Listener Failed', error);
      }
      var taskData = (_originFileMapRef$cur = originFileMapRef.current) === null || _originFileMapRef$cur === void 0 ? void 0 : _originFileMapRef$cur.videosList.find(function (item) {
        return item.id === result.id;
      });
      if ((taskData === null || taskData === void 0 ? void 0 : taskData.status) === result.status // 数据没有变更，return
      ) {
        return;
      } // 处理视频数据

      var _result = result,
        id = _result.id,
        status = _result.status,
        videoCoverUrl = _result.videoCoverUrl;
      var updateData = filterNullObj({
        id: id,
        uploadId: videoUploadIdsMap[id],
        // 视频上传的状态
        status: status,
        // 只需要展示 cover 图片
        url: videoCoverUrl,
        uploadStatus: UPLOAD_VIDEO_ERROR_STATUS.includes(status) ? UploadStatus.Fail : status === UploadMediaStatus.UploadSucceed ? UploadStatus.Success : UploadStatus.Loading
      });
      var newVideosList = (_originFileMapRef$cur2 = originFileMapRef.current) === null || _originFileMapRef$cur2 === void 0 ? void 0 : _originFileMapRef$cur2.videosList.map(function (item) {
        return item.id === id ? _objectSpread(_objectSpread({}, item), updateData) : item;
      });
      var newFile = _objectSpread(_objectSpread({}, originFileMapRef.current), {}, {
        videosList: newVideosList
      });
      originFileMapRef.current = newFile;
      callback(newFile);
    });
  }; // 检查成功上传的视频或图片
  // update:不支持视频质量检查

  var checkUploadSuccessFileList = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(succeedUploadFileList, isImage, valueIdList) {
      var checkedUploadSuccessFileList, checkedFileList, newFile, hasBadImage, succeedcheckedFileList, newValueList;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return checkQuantity(succeedUploadFileList, isImage).catch(function (error) {
                console.error('[MixedFileUpload] Check Quantity Failed', error);
              });
            case 3:
              checkedUploadSuccessFileList = _context2.sent;
              // 处理不合格的视频
              checkedFileList = isImage ? _toConsumableArray(originFileMapRef.current.imagesList) : _toConsumableArray(originFileMapRef.current.videosList);
              checkedUploadSuccessFileList === null || checkedUploadSuccessFileList === void 0 ? void 0 : checkedUploadSuccessFileList.forEach(function (file) {
                // 在fileList中查找此次成功上传的视频
                var index = checkedFileList === null || checkedFileList === void 0 ? void 0 : checkedFileList.findIndex(function (item) {
                  return item.id === file.id;
                });
                if (index !== -1) {
                  // 质量为 extremely bad, 不合格,直接删除
                  if (file.evidenceQuality === EVIDENCE_QUALITIES.EVIDENCE_QUALITY_EXTREMELY_HIGH_BBD) {
                    checkedFileList === null || checkedFileList === void 0 ? void 0 : checkedFileList.splice(index, 1);
                  } else {
                    // 质量合格,保留
                    checkedFileList === null || checkedFileList === void 0 ? void 0 : checkedFileList.splice(index, 1, _objectSpread(_objectSpread({}, file), {}, {
                      uploadStatus: UploadStatus.Checked,
                      evidenceQuality: file.evidenceQuality
                    }));
                  }
                } else {
                  checkedFileList.push(file);
                }
              });
              newFile = {
                imagesList: isImage ? checkedFileList : originFileMapRef.current.imagesList,
                videosList: isImage ? originFileMapRef.current.videosList : checkedFileList
              };
              originFileMapRef.current = newFile;
              setOriginFileMap(newFile); // 含有一个质量为 bad 需要展示警告内容

              hasBadImage = hasBadQuality(newFile === null || newFile === void 0 ? void 0 : newFile.imagesList);
              setShowWarning(hasBadImage);
              succeedcheckedFileList = [];
              checkedFileList.forEach(function (item) {
                if (
                // 检查uploadStatus是否检查过, 并且排除已经在value中的videos
                item.uploadStatus === UploadStatus.Checked && !valueIdList.includes(item.id)) {
                  succeedcheckedFileList.push(item);
                }
              }); // 将质量检查后的添加到 form

              newValueList = [].concat(_toConsumableArray(isImage ? valueMap.current.imagesList : valueMap.current.videosList), succeedcheckedFileList).filter(function (item) {
                return !!item;
              });
              onChange === null || onChange === void 0 ? void 0 : onChange(isImage ? {
                imagesList: newValueList,
                videosList: valueMap.current.videosList
              } : {
                imagesList: valueMap.current.imagesList,
                videosList: newValueList
              });
              _context2.next = 20;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](0);
              console.error('[MixedFileUpload] checkUploadSuccessFileList Failed', _context2.t0);
            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 17]]);
    }));
    return function checkUploadSuccessFileList(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }(); // 视频上传视频 处理 token 接口响应

  var handleVideoTokenResponse = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(preUploadResult, videoIdsList) {
      var formatTokens, videoUploadIdsMap, startUploadPromises, startUploadResults;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              formatTokens = formatMediaTokens(preUploadResult === null || preUploadResult === void 0 ? void 0 : preUploadResult.data); // 设置 uploadId 与 id 的映射

              videoUploadIdsMap = {}; // 开始上传

              startUploadPromises = videoIdsList.map(function (videoId, index) {
                var _preUploadResult$data, _preUploadResult$data2;
                videoUploadIdsMap[videoId] = preUploadResult === null || preUploadResult === void 0 ? void 0 : (_preUploadResult$data = preUploadResult.data) === null || _preUploadResult$data === void 0 ? void 0 : (_preUploadResult$data2 = _preUploadResult$data.vids) === null || _preUploadResult$data2 === void 0 ? void 0 : _preUploadResult$data2[index];
                return MediaSelect.mediaStartUploadWithId({
                  rootTag: rootTag,
                  id: videoId,
                  bizIdForUpload: MediaConstants.UploadBizId,
                  tokenForUpload: formatTokens === null || formatTokens === void 0 ? void 0 : formatTokens[index]
                });
              });
              _context3.next = 6;
              return Promise.all(startUploadPromises);
            case 6:
              startUploadResults = _context3.sent;
              // 获得上传的结果
              startUploadResults.forEach(function () {
                // 添加上传状态监听
                addVideosListener(videoUploadIdsMap, function (fileList) {
                  var _fileList$videosList, _fileList$videosList2;
                  setOriginFileMap(fileList); // 如果还有正在上传的就先不添加到 form

                  var loadingItem = fileList.videosList.find(function (item) {
                    return item.uploadStatus === UploadStatus.Loading;
                  });
                  if (loadingItem !== undefined) {
                    return;
                  } // 设置本次成功上传的视频

                  var succeedVideosList = []; // 获取 value 中的所有 video ids

                  var valueIdList = valueMap.current.videosList.map(function (item) {
                    return item.id;
                  });
                  fileList.videosList.forEach(function (item) {
                    if (
                    // 检查uploadStatus是否成功, 并且排除已经在value中的videos
                    item.uploadStatus === UploadStatus.Success && !valueIdList.includes(item.id)) {
                      succeedVideosList.push(item);
                    }
                  }); // 将成功上传的添加到 form

                  var newVideosList = [].concat(_toConsumableArray(valueMap.current.videosList), succeedVideosList).filter(function (item) {
                    return !!item;
                  });
                  onChange === null || onChange === void 0 ? void 0 : onChange({
                    imagesList: valueMap.current.imagesList,
                    videosList: newVideosList
                  }); // 如果所有都上传成功了就取消监听

                  if (((_fileList$videosList = fileList.videosList) === null || _fileList$videosList === void 0 ? void 0 : _fileList$videosList.length) > 0 && ((_fileList$videosList2 = fileList.videosList) === null || _fileList$videosList2 === void 0 ? void 0 : _fileList$videosList2.length) === (succeedVideosList === null || succeedVideosList === void 0 ? void 0 : succeedVideosList.length)) {
                    var _MediaSelect$mediaSto;
                    MediaSelect === null || MediaSelect === void 0 ? void 0 : (_MediaSelect$mediaSto = MediaSelect.mediaStopListeningForUploadProgress) === null || _MediaSelect$mediaSto === void 0 ? void 0 : _MediaSelect$mediaSto.call(MediaSelect, rootTag);
                  }
                });
              });
              _context3.next = 13;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);
              console.error('[MixedFileUpload] Video Upload Failed', _context3.t0);
            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 10]]);
    }));
    return function handleVideoTokenResponse(_x7, _x8) {
      return _ref3.apply(this, arguments);
    };
  }(); // 处理图片上传

  var handleImageUpload = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(imgsList) {
      var _res$imgResults, _res$imgResults2, _originFileMapRef$cur5, _originFileMapRef$cur6, res, _originFileMapRef$cur3, _originFileMapRef$cur4, _newFileList, imageWithUpLoadResList, newFileList, succeedUploadImagesList, valueIdList;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return MediaSelect.imageUpload({
                biz: MediaConstants.MMSImageBiz,
                imgsPath: imgsList === null || imgsList === void 0 ? void 0 : imgsList.map(function (file) {
                  return file.imageFilePath;
                })
              }).catch(function (error) {
                console.error('[MixedFileUpload] Image Upload Failed', error);
              });
            case 3:
              res = _context4.sent;
              if (!(!res || res.code !== 0 || (res === null || res === void 0 ? void 0 : (_res$imgResults = res.imgResults) === null || _res$imgResults === void 0 ? void 0 : _res$imgResults.length) === 0)) {
                _context4.next = 9;
                break;
              }
              _newFileList = {
                imagesList: (_originFileMapRef$cur3 = originFileMapRef.current.imagesList) === null || _originFileMapRef$cur3 === void 0 ? void 0 : (_originFileMapRef$cur4 = _originFileMapRef$cur3.filter(function (image) {
                  var _removeImageIdsList$c;
                  return !((_removeImageIdsList$c = removeImageIdsList.current) !== null && _removeImageIdsList$c !== void 0 && _removeImageIdsList$c.includes(image.id));
                })) === null || _originFileMapRef$cur4 === void 0 ? void 0 : _originFileMapRef$cur4.map(function (image) {
                  var imageObj = imgsList === null || imgsList === void 0 ? void 0 : imgsList.find(function (selectedImage) {
                    return selectedImage.id === image.id;
                  });
                  if (imageObj) {
                    return _objectSpread(_objectSpread({}, imageObj), {}, {
                      uploadStatus: UploadStatus.Fail
                    });
                  }
                  return image;
                }),
                videosList: originFileMapRef.current.videosList
              };
              originFileMapRef.current = _newFileList;
              setOriginFileMap(_newFileList);
              return _context4.abrupt("return", console.error('[MixedFileUpload] Image Upload Failed', res));
            case 9:
              // 处理有imgResults的上传结果
              imageWithUpLoadResList = res === null || res === void 0 ? void 0 : (_res$imgResults2 = res.imgResults) === null || _res$imgResults2 === void 0 ? void 0 : _res$imgResults2.map(function (imgRes, index) {
                if (imgRes.code === 0) {
                  return _objectSpread(_objectSpread({}, imgsList[index]), {}, {
                    uploadStatus: UploadStatus.Success,
                    uploadId: imgRes.imageId,
                    url: imgRes.imageUrl
                  });
                } else {
                  return _objectSpread(_objectSpread({}, imgsList[index]), {}, {
                    uploadStatus: UploadStatus.Fail
                  });
                }
              });
              newFileList = {
                imagesList: (_originFileMapRef$cur5 = originFileMapRef.current.imagesList) === null || _originFileMapRef$cur5 === void 0 ? void 0 : (_originFileMapRef$cur6 = _originFileMapRef$cur5.filter(function (image) {
                  var _removeImageIdsList$c2;
                  return !((_removeImageIdsList$c2 = removeImageIdsList.current) !== null && _removeImageIdsList$c2 !== void 0 && _removeImageIdsList$c2.includes(image.id));
                })) === null || _originFileMapRef$cur6 === void 0 ? void 0 : _originFileMapRef$cur6.map(function (image) {
                  return (imageWithUpLoadResList === null || imageWithUpLoadResList === void 0 ? void 0 : imageWithUpLoadResList.find(function (uploadedImage) {
                    return uploadedImage.id === image.id;
                  })) || image;
                }),
                videosList: originFileMapRef.current.videosList
              };
              originFileMapRef.current = newFileList;
              setOriginFileMap(newFileList); // 设置本次成功上传的图片

              succeedUploadImagesList = []; // 获取 value 中的所有 image ids

              valueIdList = valueMap.current.imagesList.map(function (item) {
                return item.id;
              });
              newFileList.imagesList.forEach(function (item) {
                if (
                // 检查 uploadStatus 是否成功, 并且排除已经在 value 中的图片
                item.uploadStatus === UploadStatus.Success && !valueIdList.includes(item.id)) {
                  succeedUploadImagesList.push(item);
                }
              }); // 检查成功上传的图片质量

              _context4.next = 18;
              return checkUploadSuccessFileList(succeedUploadImagesList, true, valueIdList).catch(function (error) {
                console.error('[MixedFileUpload] Check Quantity Failed', error);
              });
            case 18:
              _context4.next = 23;
              break;
            case 20:
              _context4.prev = 20;
              _context4.t0 = _context4["catch"](0);
              console.error('[MixedFileUpload] Image Upload Failed', _context4.t0);
            case 23:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 20]]);
    }));
    return function handleImageUpload(_x9) {
      return _ref4.apply(this, arguments);
    };
  }(); // 处理视频上传

  var handleVideosUpload = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(videoIdsList) {
      var preUploadResult;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return postVideoPreUpload === null || postVideoPreUpload === void 0 ? void 0 : postVideoPreUpload({
                amount: videoIdsList === null || videoIdsList === void 0 ? void 0 : videoIdsList.length,
                channel: 1,
                sessionId: sessionId
              }).catch(function (error) {
                console.error('[MixedFileUpload] postVideoPreUpload Failed', error);
              });
            case 3:
              preUploadResult = _context5.sent;
              // 根据 token 进行上传
              handleVideoTokenResponse(preUploadResult, videoIdsList);
              _context5.next = 10;
              break;
            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](0);
              console.error('[MixedFileUpload] postVideoPreUpload Failed', _context5.t0);
            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 7]]);
    }));
    return function handleVideosUpload(_x10) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleMediaUpload = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(result, isImage) {
      var imgsList, videoIdsList, originFiles, fileList;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              if (!(result.error !== UploadMediaResStatus.Success)) {
                _context6.next = 3;
                break;
              }
              return _context6.abrupt("return");
            case 3:
              imgsList = [];
              videoIdsList = []; // 添加loading状态

              originFiles = ((result === null || result === void 0 ? void 0 : result.data) || []).map(function (file) {
                if (!isImage && file.status === UploadMediaStatus.CompressFailed) {
                  return {
                    id: file.id,
                    uploadStatus: UploadStatus.Fail
                  };
                } else {
                  if (isImage) {
                    // 获取照片id
                    imgsList.push({
                      id: file.id,
                      imageFilePath: file.imageFilePath
                    });
                  } else {
                    // 获取视频id
                    videoIdsList.push(file.id);
                  }
                  return {
                    id: file.id,
                    uploadStatus: UploadStatus.Loading
                  };
                }
              }); // 全部设置为上传中

              fileList = {
                imagesList: isImage ? [].concat(_toConsumableArray(originFileMapRef.current.imagesList), _toConsumableArray(originFiles)) : originFileMapRef.current.imagesList,
                videosList: isImage ? originFileMapRef.current.videosList : [].concat(_toConsumableArray(originFileMapRef.current.videosList), _toConsumableArray(originFiles))
              };
              originFileMapRef.current = fileList;
              setOriginFileMap(fileList); // 分别处理图片和视频上传

              if (!isImage) {
                _context6.next = 16;
                break;
              }
              _context6.t0 = (imgsList === null || imgsList === void 0 ? void 0 : imgsList.length) > 0;
              if (!_context6.t0) {
                _context6.next = 14;
                break;
              }
              _context6.next = 14;
              return handleImageUpload(imgsList).catch(function (error) {
                console.error('[MixedFileUpload] Image Upload Failed', error);
              });
            case 14:
              _context6.next = 20;
              break;
            case 16:
              _context6.t1 = (videoIdsList === null || videoIdsList === void 0 ? void 0 : videoIdsList.length) > 0;
              if (!_context6.t1) {
                _context6.next = 20;
                break;
              }
              _context6.next = 20;
              return handleVideosUpload(videoIdsList).catch(function (error) {
                console.error('[MixedFileUpload] Video Upload Failed', error);
              });
            case 20:
              _context6.next = 25;
              break;
            case 22:
              _context6.prev = 22;
              _context6.t2 = _context6["catch"](0);
              console.error('[MixedFileUpload] Upload Failed', _context6.t2);
            case 25:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 22]]);
    }));
    return function handleMediaUpload(_x11, _x12) {
      return _ref6.apply(this, arguments);
    };
  }();
  var nativeMediaUpload = function nativeMediaUpload(isImage) {
    MediaSelect.mediaSelect({
      rootTag: rootTag,
      source: MediaSourceType.AlbumAndCamera,
      mediaType: isImage ? MediaType.Image : MediaType.Video,
      maxSelectCount: isImage ? restImageNum : videoProps.maxFileNum,
      videoMiniDuration: 1,
      videoMaxSize: isImage ? imageProps.maxFileSize : videoProps.maxFileSize,
      bizIdForMediaSDK: MediaConstants.MediaBizId
    }).then(function (res) {
      handleMediaUpload(res, isImage);
    }).catch(function (error) {
      console.error('[MixedFileUpload] Select Media Failed', error);
    });
  };
  var lastImgIndexsInEveryRow = [];
  for (var i = MIX_MEDIA_IN_ROW_COUNT - 1; i < imageProps.maxFileNum; i += MIX_MEDIA_IN_ROW_COUNT) {
    lastImgIndexsInEveryRow.push(i);
  }
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: styles.pictureUploadWrapper
  }, originFileMap.imagesList.length !== 0 && /*#__PURE__*/React.createElement(React.Fragment, null, originFileMap.imagesList.map(function (file, index) {
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.mediaWrapper, {
        marginRight: lastImgIndexsInEveryRow.includes(index) ? 0 : MIX_MEDIA_MARGIN_RIGHT
      }],
      key: file.id
    }, /*#__PURE__*/React.createElement(Image, {
      style: styles.mediaItem,
      source: {
        uri: file === null || file === void 0 ? void 0 : file.url
      }
    }), /*#__PURE__*/React.createElement(Pressable, {
      style: styles.mediaRemoveIconWrapper,
      onPress: function onPress() {
        return handleRemove(index, file, true);
      }
    }, /*#__PURE__*/React.createElement(MediaDelete, {
      style: styles.mediaRemoveIcon
    })), file.uploadStatus === UploadStatus.Loading ? /*#__PURE__*/React.createElement(Pressable, {
      style: [styles.mediaMaskWrapper, styles.mediaLoadingMaskWrapper]
    }, /*#__PURE__*/React.createElement(Image, {
      style: styles.mediaLoadingIcon,
      source: Loading
    })) : null, file.uploadStatus === UploadStatus.Fail ? /*#__PURE__*/React.createElement(Pressable, {
      style: styles.mediaMaskWrapper,
      onPress: function onPress() {
        return handleRetry(index, file, true);
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.failedIconWrapper
    }, /*#__PURE__*/React.createElement(UploadFailed, {
      style: styles.mediaFailedIcon
    })), /*#__PURE__*/React.createElement(Text, {
      style: styles.mediaFailedText
    }, "Retry")) : null);
  })), showImageUploadIcon && /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: function onPress() {
      return nativeMediaUpload(true);
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.mediaUploadItemWrapper, !lastImgIndexsInEveryRow.includes(originFileMap.imagesList.length) && {
      marginRight: MIX_MEDIA_MARGIN_RIGHT
    }]
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.mediaUploadIconWrapper
  }, /*#__PURE__*/React.createElement(UploadImage, {
    style: styles.mixedmediaUploadIcon
  }), imageProps.maxFileNum && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
    style: styles.mediaUploadWithEnquiredText
  }, imageProps.uploadText || 'Upload Photo', ' ', imageProps.required ? /*#__PURE__*/React.createElement(Text, {
    style: styles.mediaUploadWithEnquired
  }, "*") : null), /*#__PURE__*/React.createElement(Text, {
    style: styles.mediaUploadWithEnquiredText
  }, "(", originFileMap.imagesList.length, "/", imageProps.maxFileNum, ")"))))), originFileMap.videosList.length !== 0 && /*#__PURE__*/React.createElement(React.Fragment, null, originFileMap.videosList.map(function (file, index) {
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.mediaWrapper, {
        marginRight: 0
      }],
      key: file.id
    }, /*#__PURE__*/React.createElement(Image, {
      style: styles.mediaItem,
      source: {
        uri: file === null || file === void 0 ? void 0 : file.url
      }
    }), /*#__PURE__*/React.createElement(Pressable, {
      style: styles.mediaRemoveIconWrapper,
      onPress: function onPress() {
        return handleRemove(index, file, false);
      }
    }, /*#__PURE__*/React.createElement(MediaDelete, {
      style: styles.mediaRemoveIcon
    })), file.uploadStatus === UploadStatus.Loading ? /*#__PURE__*/React.createElement(Pressable, {
      style: [styles.mediaMaskWrapper, styles.mediaLoadingMaskWrapper]
    }, /*#__PURE__*/React.createElement(Image, {
      style: styles.mediaLoadingIcon,
      source: Loading
    })) : null, file.uploadStatus === UploadStatus.Fail ? /*#__PURE__*/React.createElement(Pressable, {
      style: styles.mediaMaskWrapper,
      onPress: function onPress() {
        return handleRetry(index, file, false);
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.failedIconWrapper
    }, /*#__PURE__*/React.createElement(UploadFailed, {
      style: styles.mediaFailedIcon
    })), /*#__PURE__*/React.createElement(Text, {
      style: styles.mediaFailedText
    }, "Retry")) : null);
  })), showVideoUploadIcon && /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: function onPress() {
      return nativeMediaUpload(false);
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.mediaUploadItemWrapper]
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.mediaUploadIconWrapper
  }, /*#__PURE__*/React.createElement(UploadVideo, {
    style: styles.mixedmediaUploadIcon
  }), videoProps.maxFileNum && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
    style: styles.mediaUploadWithEnquiredText
  }, videoProps.uploadText || 'Upload Video', ' ', videoProps.required ? /*#__PURE__*/React.createElement(Text, {
    style: styles.mediaUploadWithEnquired
  }, "*") : null), /*#__PURE__*/React.createElement(Text, {
    style: styles.mediaUploadWithEnquiredText
  }, "(", originFileMap.videosList.length, "/", videoProps.maxFileNum, ")")))))), showWarning && /*#__PURE__*/React.createElement(View, {
    style: styles.warningWrapper
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.warningText
  }, warningText)));
};
export default module.exports;